import { createStaticVNode, defineComponent, openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g id="p1-\u898F\u7BC4\u8207\u5207\u5716" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="p1-header/\u641C\u5C0B\u4EA4\u4E92" transform="translate(-1512.000000, -1289.000000)"><g id="web/header/1920-1280\u5167\u5BB9\u5BEC\u5EA6\u5907\u4EFD" transform="translate(0.000000, 1269.000000)"><g id="web/header/search/\u6FC0\u6D3B" transform="translate(1268.000000, 14.000000)"><g id="search-icon-\u9EDE\u64CA\u5340\u57DF" transform="translate(236.000000, 4.000000)"><g id="icon_header_search_white" transform="translate(8.000000, 2.000000)"><rect id="bg" x="0" y="0" width="24" height="24"></rect><path id="\u5F62\u72B6\u7ED3\u5408" d="M11.3346928,4 C15.3855317,4 18.6693855,7.2838538 18.6693855,11.3346928 C18.6693855,13.0388228 18.0882207,14.6072146 17.1132755,15.8524834 L19.7387225,18.47734 C20.0870925,18.8257101 20.0870925,19.3905295 19.7387225,19.7388995 C19.3903525,20.0872695 18.8255331,20.0872695 18.4771631,19.7388995 L15.8524834,17.1132755 C14.6072146,18.0882207 13.0388228,18.6693855 11.3346928,18.6693855 C7.2838538,18.6693855 4,15.3855317 4,11.3346928 C4,7.2838538 7.2838538,4 11.3346928,4 Z M11.3346928,5.78411445 C8.26919301,5.78411445 5.78411445,8.26919301 5.78411445,11.3346928 C5.78411445,14.4001925 8.26919301,16.8852711 11.3346928,16.8852711 C14.4001925,16.8852711 16.8852711,14.4001925 16.8852711,11.3346928 C16.8852711,8.26919301 14.4001925,5.78411445 11.3346928,5.78411445 Z" fill="#FFFFFF" fill-rule="nonzero"></path></g></g></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
const __default__ = defineComponent({
  name: "TvbSearchWhiteIcon"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  setup(__props) {
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=SearchWhite.vue2.mjs.map
